import React from "react";

const IconGlobeUnregister = ({ color = "#EA8124" }) => {
  return (
    <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path 
        d="M11.25 1.5L15 5.25M0.750003 8.25H15.75C15.75 9.73336 15.3101 11.1834 14.486 12.4168C13.6619 13.6501 12.4906 14.6114 11.1201 15.1791C9.74968 15.7468 8.24168 15.8953 6.78683 15.6059C5.33197 15.3165 3.9956 14.6022 2.9467 13.5533C1.89781 12.5044 1.1835 11.168 0.894114 9.71318C0.604725 8.25832 0.75325 6.75032 1.32091 5.37987C1.88856 4.00943 2.84986 2.83809 4.08323 2.01398C5.3166 1.18987 6.76664 0.75 8.25 0.75C6.32418 2.77212 5.25 5.45756 5.25 8.25C5.25 11.0424 6.32418 13.7279 8.25 15.75C10.1758 13.7279 11.25 11.0424 11.25 8.25M15 1.5L11.25 5.25" 
        stroke={color} 
        strokeWidth="1.5" 
        strokeLinecap="round" 
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default IconGlobeUnregister;